import React from 'react';
import { injectIntl } from 'react-intl';
import { getLayout, i18nIntl } from '../../lib/ep.js';

import BuilderCanvas from './BuilderCanvas';
import Message from './Message';

const DesignWarningMessage = (props) => {
	const promo = props?.promo ?? false;
	if(promo === false) return null;
	
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const layout_props = getLayout(promo);

	const stage = props?.stage ?? false;
	const display_header = (promo.config.custom_menu != undefined && promo.config.custom_menu.status == "0") ? false : true;
	const display_footer = promo?.display_footer ?? true;

	let page = props?.page ?? false;
	const page_original = page + '';
	if(page == 'stage' && !stage) page = 'quiz';

	const generic_container_class = {
		width:'60',
		num_cols:'1',
		cols_prop:'30',
	};

	const content_styles = {
		position:'relative',
		zIndex:3,
	};

	let container_classes = generic_container_class;

	if(page == 'ranking') {
		page = 'entries';
	}

	switch(page) {
		case 'stage':
			container_classes = {
				width:stage?.layout_width ?? '60',
				num_cols:stage?.layout_num_cols ?? '1',
				cols_prop:stage?.layout_cols_prop ?? '50',
			};
			break;

		default:
			if(promo.config.layout[page] != undefined) container_classes = promo.config.layout[page];
			break;
	}

	const cls = ['content_simulator', `_wg${container_classes.width}`, `_prop${((container_classes.cols_prop != undefined && parseInt(container_classes.cols_prop) > 35) ? container_classes.cols_prop : 30)}`, (parseInt(container_classes.num_cols) === 1) ? 'single_columned' : 'double_columned'];

	return (
		<BuilderCanvas
			not_bordered={true}
			off_content={(page_original == 'ranking') ? (
				<div>
					<Message
						title="Ranking page is forced to be on top of the page"
						_class={{ other:'in_top in_bottom' }}
					/>
				</div>
			) : null}
		>
			<div class="gui_background_preview">
				<div>
					<div>
						<div class="content_simulator_legend_content">
							<div>
								<ul class="content_simulator_legend not_awesome" style={(page != false) ? { bottom:0 } : null}>
									<li>{i18n("Desktop")}</li>
									<li>{i18n("Portrait mobile")}</li>
									<li>{i18n("Landscape mobile")}</li>
									<li>{i18n("Portrait tablet")}</li>
									<li>{i18n("Desktop")}</li>
								</ul>
							</div>
						</div>

						{(display_header) && (
							<div class="header_simulator" style={{background:`rgba(var(--header-background-color))`}} />
						)}

						<div class="bg_simulator">
							<div class="is_fullscreen relative_to_container" style={{ backgroundColor:`rgba(var(--background-color-hi-contrast), 0.8)` }} />

							<div class={cls.join(" ")} style={content_styles}>
								<div class="fake_content _is_fullscreen _relative_to_container">
									<div class="media" style={{backgroundColor:`rgba(var(--text-color-hi-contrast), 0.4)`}}>
										<img src={`${window.cdn_url}img/blank_1x1.png`} width="100%" alt="" />
									</div>

									<div class="textual" style={{width:'100%', flexGrow:'1'}}>
										<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
											<defs>
												<pattern id="text_lines" width='100%' height="12" patternUnits="userSpaceOnUse">
													<path d="M 0 2.5 L 0 2.5 3000 2.5" fill="none" stroke='rgba(var(--text-color-hi-contrast), 0.4)' strokeWidth="6" />
												</pattern>
											</defs>

											<rect width="100%" height="100%" y="0" fill="url(#text_lines)" />
										</svg>
									</div>
								</div>
							</div>
						</div>

						{(display_footer) && (
							<div class="footer_simulator" style={{background:'rgba(var(--footer-background-color))'}} />
						)}
					</div>
				</div>
			</div>
		</BuilderCanvas>
	)
}

export default injectIntl(DesignWarningMessage);